/**
 * .text_content 반응형 폰트 — 959px 이하에서 0.875rem → 0.75rem 전환(입력 폰트 포함).
 */
export const textContentFontStyles = `
  .text_content {
    font-size : 0.875rem;
    @media (max-width: 959px) {
      font-size : 0.75rem;

      .MuiInputBase-input{
        font-size :0.75rem;
      }
    }
  }
`;

/** 삭제된 데이터 표시 — .deleted_data. mes MainWrapper base·DeviceDetailMainWrapper 2곳 바이트 동일(들여쓰기만 차이) */
export const deletedDataStyles = `
  .deleted_data {
    margin-left: 6px;
    font-weight: bold;
    color: #da3636;
  }
`;

/** 수리 이력 라벨/등록 버튼 — .parts_history_label/.parts_history_add_button. mes MainWrapper base·DeviceDetailMainWrapper 2곳 바이트 동일(들여쓰기만 차이) */
export const partsHistoryStyles = `
  .parts_history_label {
    display: flex;
    justify-content: space-between;
  }
  .parts_history_add_button {
    margin-top: 0px;
    @media (max-width: 899px) {
      margin-top: -18px;
    }
    display: flex;
    justify-content: end;
  }
`;

/** 액션·가져오기 버튼 행 — .action_and_import_button. location/InspectionDetail/MaintenanceDetail MainWrapper 3곳 바이트 동일(들여쓰기만 차이) */
export const actionAndImportButtonStyles = `
  .action_and_import_button {
    display: flex;
    justify-content: space-between;
  }
`;

/** BOM 목록/추가 버튼 — .bom_list/.bom_add_button. MesMainWrapperWithBomList·DeviceDetailMainWrapper 2곳 바이트 동일 */
export const bomListStyles = `
  .bom_list {
    display: flex;
    justify-content: space-between;
  }
  .bom_add_button {
    margin-top: 28px;
    @media (max-width: 899px) {
      margin-top: 3px;
    }
  }
`;

/**
 * CreateDeviceModal 계열 MainContentWrapper 골격(정본 base) — 주소/태그/칩 삭제 아이콘 공통 세트 +
 * .company_location_checkbox{margin-top:10px}(최빈값). 페이지별 margin-top/margin-bottom 재지정,
 * withDatepickerPopper·withMinWidthZero 추가분은 이 base를 확장(styled(Base))해 뒤에 이어붙인다.
 */
export const mainContentWrapperCreateDeviceStyles = (theme: any) => `
    flex-grow: 1;

    .MuiInputAdornment-root {
      opacity: 0.5;
    }

    .device_location_textfield {
      label {
        padding-right: 30px;
        text-overflow: ellipsis !important;
      }
    }

    #device-tags {
      text-transform: lowercase !important;
    }

    .address_clear_icon,
    .MuiAutocomplete-clearIndicator {
        z-index: 10000 !important;
        padding: 4px;
        font-size: 1.5rem;
        color: ${theme.palette.grey[500]} !important;
        background: transparent;
        :hover {
          opacity: 0.7;
          background: ${theme.palette.grey[200]};
        }
      }
    }

    .MuiChip-deleteIcon {
      color: rgba(255, 25, 67, 0.7) !important;
      :hover {
        color: rgba(255, 25, 67, 0.3) !important;
      }
    }

    .company_location_checkbox {
      margin-top: 10px;
    }
`;

/** CreateDeviceModal 계열 datepicker popper 확장 — InspectionDetail/InspectionList 2곳에서 사용 */
export const createDeviceDatepickerPopperStyles = (theme: any) => `
  .react-datepicker-popper {
    z-index: 9999 !important;
  }

  .react-datepicker-wrapper {
    .react-datepicker__close-icon {
      margin-right: 0.85rem;
    }
    .react-datepicker__close-icon::after {
      background-color: ${theme.palette.primary.main};
    }
  }
`;
